const DASHBOARD = '/';
const MINT_CONTRACT = '/mint-contract';
const MY_CONTRACT = '/my-contract';

export default {
  DASHBOARD,
  MINT_CONTRACT,
  MY_CONTRACT,
};
